import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import TheLayout from '../../layout/TheLayout';
import FirstView from '../../asset/firstview.png';
import NavSidebar from '../Util/NavSidebar/NavSidebar';
import ProductItem from '../Util/ProductItem/ProductItem';
import AboutRegular from '../Util/About/AboutRegular';
import {
  getProductList,
} from '../../redux/actions/product';

const keywords = ['TERRA', '定期便', 'subscription'];

const Subscription = () => {
  const productList = useSelector((state) => state.product.productList, shallowEqual);
  const productSubList = [];
  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    dispatch(getProductList(Number(process.env.REACT_APP_COMPANY_ID), -1, 0));
  }, [dispatch]);

  productList.forEach((item) => {
    if (item.product_categories[0]?.category_name === '定期便') {
      productSubList.push(item);
    }
  });
  return (
    <TheLayout>
      <Helmet
        meta={[{
          name: 'keyword',
          content: keywords.join(),
        }]}
      >
        <title>定期便｜株式会社TERRA</title>
      </Helmet>
      <div className="subscription">
        <div
          className="first_view d-flex align-items-center justify-content-center"
          style={{
            backgroundImage: `url(${FirstView})`,
            backgroundSize: '100% 100%',
            height: '15vh',
            fontSize: '2rem',
            letterSpacing: '1rem',
            color: 'white',
          }}
        >
          定期便
        </div>
        <div className="d-none d-lg-block bg-white">
          <div className="container pl-0">
            <nav>
              <ol className="breadcrumb" style={{ color: 'rgb(181,189,185)' }}>
                <li className="breadcrumb-item">
                  <Link style={{ textDecoration: 'none', color: 'rgb(181,189,185)' }} to="/">ホーム</Link>
                </li>
                <li className="mx-2">&#62;</li>
                <li>定期便</li>
              </ol>
            </nav>
          </div>
        </div>
        <div className="content container">
          <div className="row">
            <div className="col-3 d-none d-lg-block p-0" style={{ background: 'white' }}>
              <NavSidebar />
            </div>
            <div className="col-12 col-lg-9">
              <div className="p-2">
                <div className="subscription-list row">
                  {
                    productSubList.map((item) => (
                      <ProductItem
                        key={item.id}
                        id={item.id}
                        imgUrl={item.main_image}
                        type={item.type}
                        name={item.name}
                        price={item.price}
                        page="subscription"
                        isSubscription
                        label
                      />
                    ))
                  }
                </div>
                <AboutRegular />
              </div>
            </div>
          </div>
        </div>
      </div>
    </TheLayout>
  );
};

export default Subscription;
